import Image from '@/components/Image';
import { useGlobalData } from '@/context/global';
import { loginotpsend } from '@/services/auth';
import { formatMobileForBackend } from '@/utils/global';
import { MobileValidation } from '@/utils/valitation/auth';
import { getCookie } from 'cookies-next';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import React from 'react';
import toast from 'react-hot-toast';

function LoginSendOtp({ t, setShow, mobile }) {
  const { dispatch } = useGlobalData();
  const handleSendOtp = async (values, { setSubmitting }) => {
    const handshake = getCookie('handshake');
    setSubmitting(true);
    const mobileWithCode = formatMobileForBackend(values.mobile);
    if (!mobileWithCode) {
      toast.error(t('TelephoneRequired'));
      setSubmitting(false);
      return;
    }
    const res = await loginotpsend(handshake, mobileWithCode);
    console.log('login send otp response', res);
    if(!res?.data && res?.error?.success == 'false'){
      toast.error(t(res.error?.error || 'Something went wrong'));
      setSubmitting(false);
    }else{
      console.log('success', res?.data?.data?.successmsg);
      toast.success(res?.data?.data?.successmsg || t('OTP sent successfully'));
      dispatch({ type: 'SET_MOBILE', payload: mobileWithCode });
      setShow('verifyotp');
      setSubmitting(false);
    }
  };

  return (
    <section className='mt-3 sm:mt-5'>
      <Formik
        onSubmit={handleSendOtp}
        initialValues={{
          mobile: mobile || '',
        }}
        validationSchema={MobileValidation(t)}
      >
        {({ isSubmitting }) => (
          <Form>
            <div className='col-span-full *:mb-1'>
              <label htmlFor='mobile' className='block text-start'>
                {t('Phone Number')}
              </label>
              <div
                dir='ltr'
                className='flex w-full items-center rounded-md border p-1.5'
              >
                <Image
                  loading='eager'
                  className='rounded-sm'
                  src='/imgs/KSA.svg'
                  height={30}
                  width={30}
                  alt='KSA Img !'
                />
                <span className='mx-1.5 text-zinc-500 max-sm:text-sm'>
                  +966
                </span>
                <Field
                  className='flex-grow w-full outline-none max-sm:text-sm max-sm:placeholder:text-sm sm:p-2'
                  name='mobile'
                  dir={'ltr'}
                  placeholder={'5xxxxxxxx'}
                  type='text'
                  id='mobile'
                  maxLength={9}
                />
              </div>

              <ErrorMessage
                component='div'
                name='mobile'
                className='block mt-1 mb-4 text-sm text-red-600 text-start max-sm:text-xs'
              />
            </div>
            <button
              disabled={isSubmitting}
              className='flex items-center justify-center w-full gap-4 p-2 mt-4 font-semibold text-white rounded-md bg-primary hover:bg-primary/90 max-sm:text-sm'
            >
              {isSubmitting && (
                <span className='border-2 border-t border-r border-white rounded-full size-4 animate-spin' />
              )}
              <span>{t('Send OTP')}</span>
            </button>
          </Form>
        )}
      </Formik>
    </section>
  );
}

export default LoginSendOtp;
